// extracted by mini-css-extract-plugin
module.exports = {"desktop":"min-width: 75em","furtherInfo":"FurtherInfo_furtherInfo__nTAKB","popover":"FurtherInfo_popover__OiA_k"};